module.exports = __webpack_public_path__ + "static/img/about.5876cc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/about.png
// module id = RhaQ
// module chunks = 44